/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import LogoWhite from '../../assets/images/webp/logo_intertennis_white.webp'
import LogoColor from '../../assets/images/webp/logo_intertennis_color.webp'
import LogoBall from '../../assets/images/logo_tilted_transparent_128.png'
import FranceFlag from '../../assets/svgs/flag-france.svg'
import GermanyFlag from '../../assets/svgs/flag-germany.svg'
import SpainFlag from '../../assets/svgs/flag-spain.svg'
import EngFlag from '../../assets/svgs/flag-uk.svg'
import ItalyFlag from '../../assets/svgs/flag-italy.svg'
import PortugalFlag from '../../assets/svgs/flag-portugal.svg'
import GreeceFlag from '../../assets/svgs/flag-greece.svg'
import { setCookie } from '../../utils/cookies'
import { useTranslation } from 'react-i18next'
import Select, { components } from 'react-select'
import IconOptions from '../iconOptions'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from '../../context/ThemeContext'

export const languagePptions = [
    { value: 'en', label: 'EN', icon: EngFlag },
    { value: 'de', label: 'DE', icon: GermanyFlag },
    { value: 'fr', label: 'FR', icon: FranceFlag },
    { value: 'es', label: 'ES', icon: SpainFlag },
    { value: 'it', label: 'IT', icon: ItalyFlag },
    { value: 'pt', label: 'PT', icon: PortugalFlag },
    { value: 'el', label: 'EL', icon: GreeceFlag },
]

const Navbar = ({ setShowSignUpPopup }) => {
    const [showNavbar, setShowNavbar] = useState(false)
    const [showNavbarMobile, setShowNavbarMobile] = useState(false)
    const [activeLink, setActiveLink] = useState("/")
    const { t, i18n } = useTranslation()
    const { isDarkMode } = useTheme()
    const navigate = useNavigate()
    const location = useLocation()
    const [activeLanguage, setActiveLanguage] = useState(languagePptions[0])
    const [language, setLanguage] = useState('en')

    useEffect(() => {
        let lastScrollY = window.scrollY
        let ticking = false

        const handleScroll = () => {
            if (ticking) return
            ticking = true
            requestAnimationFrame(() => {
                const currentY = window.scrollY
                const heroEl = document.getElementById('AG_HERO_TRUE_SECTION')
                const heroBottom = heroEl ? heroEl.getBoundingClientRect().height : 600

                // Hide during hero section
                if (currentY < heroBottom * 0.6) {
                    setShowNavbar(false)
                    setShowNavbarMobile(false)
                }
                // Scrolling UP → show navbar
                else if (currentY < lastScrollY - 10) {
                    setShowNavbar(true)
                }
                // Scrolling DOWN → hide navbar
                else if (currentY > lastScrollY + 10) {
                    setShowNavbar(false)
                    setShowNavbarMobile(false)
                }

                lastScrollY = currentY
                ticking = false
            })
        }
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        if (location.pathname === '/') {
            if (location.hash) {
                setActiveLink(location.hash.replace('#', ''))
            } else {
                setActiveLink('/')
            }
        } else {
            setActiveLink(location.pathname)
        }
    }, [location.pathname, location.hash])

    const SingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
            <div className="flex gap-2 items-center">
                <div className="w-6">
                    <img
                        src={activeLanguage.icon}
                        alt={`${activeLanguage.label} Flag`}
                        className="object-contain"
                        width={100}
                        height={100}
                    />
                </div>
                <p className="">{children}</p>
            </div>
        </components.SingleValue>
    )

    const handleLangChange = (e) => {
        setCookie('user_language_preference', e.value, 30)
        setActiveLanguage(e)
        var htmlElement = document.querySelector('html')
        setShowNavbarMobile(false);
        htmlElement.lang = e.value
        setLanguage(e.value)
        i18n.changeLanguage(e.value)
    }

    function scrollToSection(id) {
        setActiveLink(id)
        const section = document.getElementById(id)
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' })
        }
    }

    let navLinks = (
        <>
            <li className={activeLink == "/" ? "active-link" : ""}>
                <Link to="/" onClick={() => { setActiveLink("/"); setShowNavbarMobile(false); }}>{t('navbar.home')}</Link>
            </li>
            <li className={activeLink == "gettingStart" ? "active-link" : ""}>
                <a
                    role="button"
                    onClick={() => {
                        if (location.pathname !== '/') {
                            navigate('/#gettingStart');
                        } else {
                            scrollToSection('gettingStart');
                        }
                        setShowNavbarMobile(false);
                    }}
                >
                    {t('navbar.how_to_use')}
                </a>
            </li>
            <li className={activeLink == "features" ? "active-link" : ""}>
                <a
                    role="button"
                    onClick={() => {
                        if (location.pathname !== '/') {
                            navigate('/#features');
                        } else {
                            scrollToSection('features');
                        }
                        setShowNavbarMobile(false);
                    }}
                >
                    {t('navbar.features')}
                </a>
            </li>
            <li className={activeLink == "/referral-program" ? "active-link" : ""} style={{ width: "min-content" }} >
                <Link to="/referral-program" onClick={() => { setActiveLink("/referral-program"); setShowNavbarMobile(false); }}>{t('navbar.referral_program')}</Link>
            </li>
            <li className={activeLink == "faqs" ? "active-link" : ""}>
                <a
                    role="button"
                    onClick={() => {
                        if (location.pathname !== '/') {
                            navigate('/#faqs');
                        } else {
                            scrollToSection('faqs');
                        }
                        setShowNavbarMobile(false);
                    }}
                >
                    {t('navbar.faqs')}
                </a>
            </li>
        </>
    )
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    const menuPlacement = isMobile ? 'top' : 'bottom'
    const MobileSingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
            <div className="flex items-center justify-center">
                <div className="w-6">
                    <img
                        src={activeLanguage.icon}
                        alt={`${activeLanguage.label} Flag`}
                        className="object-contain"
                        width={100}
                        height={100}
                    />
                </div>
            </div>
        </components.SingleValue>
    )

    let SelectLangueage = (
        <Select
            className="language-select z-10"
            defaultValue={{
                label: activeLanguage.label,
                value: activeLanguage.value,
            }}
            options={languagePptions}
            onChange={(e) => {
                handleLangChange(e)
            }}
            isSearchable={false}
            placeholder={() => ''}
            styles={{
                singleValue: (base) => ({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                    color: 'var(--text-primary)',
                }),
                control: (base) => ({
                    ...base,
                    background: 'transparent',
                    borderColor: 'var(--border-color)',
                    minHeight: '36px',
                    boxShadow: 'none',
                    '&:hover': {
                        borderColor: 'var(--primary)',
                    },
                }),
                menu: (base) => ({
                    ...base,
                    background: '#ffffff',
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    overflow: 'hidden',
                }),
                option: (base, state) => ({
                    ...base,
                    color: '#1a1a1a',
                    backgroundColor: state.isFocused ? '#f0f0f0' : '#ffffff',
                    cursor: 'pointer',
                    '&:active': {
                        backgroundColor: '#e0e0e0',
                    },
                }),
                input: (base) => ({
                    ...base,
                    color: 'var(--text-primary)',
                }),
                indicatorSeparator: () => ({
                    display: 'none',
                }),
                dropdownIndicator: (base) => ({
                    ...base,
                    color: 'var(--text-primary)',
                    '&:hover': {
                        color: 'var(--primary)',
                    },
                }),
            }}
            menuPlacement={menuPlacement}
            components={{
                Option: IconOptions,
                SingleValue,
            }}
        />
    )

    let SelectLangueageMobile = (
        <Select
            className="language-select-mobile z-10"
            defaultValue={{
                label: activeLanguage.label,
                value: activeLanguage.value,
            }}
            options={languagePptions}
            onChange={(e) => {
                handleLangChange(e)
            }}
            isSearchable={false}
            placeholder={() => ''}
            styles={{
                container: (base) => ({
                    ...base,
                    width: '48px',
                }),
                singleValue: (base) => ({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--text-primary)',
                    margin: 0,
                }),
                control: (base) => ({
                    ...base,
                    background: 'transparent',
                    borderColor: 'var(--border-color)',
                    minHeight: '34px',
                    boxShadow: 'none',
                    padding: 0,
                    '&:hover': {
                        borderColor: 'var(--primary)',
                    },
                }),
                valueContainer: (base) => ({
                    ...base,
                    padding: '0 4px',
                    justifyContent: 'center',
                }),
                menu: (base) => ({
                    ...base,
                    background: '#ffffff',
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    width: '140px',
                }),
                option: (base, state) => ({
                    ...base,
                    color: '#1a1a1a',
                    backgroundColor: state.isFocused ? '#f0f0f0' : '#ffffff',
                    cursor: 'pointer',
                    '&:active': {
                        backgroundColor: '#e0e0e0',
                    },
                }),
                input: (base) => ({
                    ...base,
                    color: 'var(--text-primary)',
                    margin: 0,
                    padding: 0,
                }),
                indicatorSeparator: () => ({
                    display: 'none',
                }),
                dropdownIndicator: () => ({
                    display: 'none',
                }),
            }}
            menuPlacement="top"
            components={{
                Option: IconOptions,
                SingleValue: MobileSingleValue,
            }}
        />
    )

    return (
        <>
            <nav
                style={{
                    backdropFilter: 'blur(12px)',
                    background: 'var(--nav-bg)',
                    borderBottom: '1px solid var(--border-color)',
                }}
                className={`fixed w-full ${showNavbar ? 'shadow-lg top-0' : '-top-24'
                    } transition-all duration-500 ease-in-out z-50 h-20 max-xl:hidden`}
            >
                <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-3">
                    <a
                        href="#"
                        className="flex items-center space-x-3 rtl:space-x-reverse"
                    >
                        <img
                            src={isDarkMode ? LogoWhite : LogoColor}
                            className="h-14"
                            alt="Inter Tennis Logo"
                        />
                    </a>
                    <div
                        className={`block w-full md:block md:w-auto`}
                        id="navbar-default"
                    >
                        <ul
                            className={`font-medium flex flex-col p-4 md:p-0 mt-4 border border-border-color rounded-lg md:flex-row md:space-x-[1rem] rtl:space-x-reverse md:mt-0 md:border-0 w-max text-text-primary`}
                            id="nav-ul"
                        >
                            {navLinks}
                            {SelectLangueage}
                            <button
                                onClick={() => setShowSignUpPopup(true)}
                                className="block py-2 px-3 glow-yellow"
                                aria-current="page"
                            >
                                <div className="btn-background"></div>
                                <span className="relative z-10 flex items-center justify-center gap-3">
                                    {t("navbar.button")}
                                    <img src={LogoBall} alt="Tennis Ball Icon" className="h-7 w-auto group-hover:rotate-12 transition-transform" />
                                </span>
                            </button>
                            <span className="nav-promo-text">
                                <span className="nav-promo-text__line1">{t('meta.home.freeBanner.line1')}</span>
                                <span className="nav-promo-text__line2">{t('meta.home.freeBanner.line2')}</span>
                            </span>
                        </ul>
                    </div>
                </div>
            </nav>
            <nav
                style={{
                    backdropFilter: 'blur(12px)',
                    background: 'var(--nav-bg)',
                    borderTop: '1px solid var(--border-color)',
                }}
                className={`fixed w-full bottom-0 ${showNavbar ? 'translate-y-0 shadow-lg' : 'translate-y-full'
                    } transition-transform duration-500 ease-in-out z-50 h-16 xl:hidden`}
            >
                <div className="max-w-screen-xl flex items-center gap-2 mx-auto mt-2 px-3">
                    <div className="flex-shrink-0">
                        {SelectLangueageMobile}
                    </div>

                    <div
                        className={`${showNavbarMobile
                            ? 'fixed bottom-0 left-0 transform  -translate-y-16'
                            : 'hidden'
                            } w-full xl:block xl:w-auto`}
                        id="navbar-default"
                    >
                        <ul
                            className="font-medium flex flex-col p-4 xl:p-0 mt-4 border border-border-color rounded-lg xl:flex-row xl:space-x-8 rtl:space-x-reverse xl:mt-0 xl:border-0 text-text-primary mb-4 xl:mb-0"
                            id="nav-ul"
                            style={{ background: 'var(--nav-bg)' }}
                        >
                            {navLinks}
                            {SelectLangueage}
                        </ul>
                    </div>
                    <div className="flex-1 flex items-center justify-center gap-2">
                        <span className="nav-promo-text nav-promo-text--mobile">
                            <span className="nav-promo-text__line1">100</span>
                            <span className="nav-promo-text__line1">shots</span>
                            <span className="nav-promo-text__line2">FREE</span>
                        </span>
                        <button
                            onClick={() => setShowSignUpPopup(true)}
                            className="block py-2 px-3 glow-yellow flex items-center"
                            aria-current="page"
                        >
                            <div className="btn-background"></div>
                            <span className="mr-1">{t("navbar.button")}</span>
                            <img src={LogoBall} alt="Tennis Ball Icon" className="h-6 w-auto glow-icon" />
                        </button>
                    </div>
                    <div className="flex-shrink-0">
                        <button
                            onClick={() =>
                                setShowNavbarMobile(!showNavbarMobile)
                            }
                            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg xl:hidden text-text-primary"
                            aria-controls="navbar-default"
                            aria-expanded={showNavbarMobile ? 'true' : 'false'}
                        >
                            <span className="sr-only">Open main menu</span>
                            <svg
                                className="w-5 h-5"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 17 14"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M1 1h15M1 7h15M1 13h15"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navbar

